/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const Option = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.Option;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

Option.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      Option: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

Option.defaultProps = {
  selectProps: {
    custom: {
      Option: null,
    },
  },
  children: null,
};

export default Option;
